// 比較アプリ(Comparable Products)の挙動上書き
// アプリJSは商品の追加/削除クリック時に必ず比較モーダル(compare-bar)を自動で開くため、
// クリック直後にモーダルを不可視化し、イベント処理完了後に正規の閉じるボタンで閉じる。
// モーダルはフロートの「商品比較」ボタン(comparable-sticky-button)押下時のみ開く。
// 注意1: CSSやクラス操作で隠すだけでは、アプリが比較モード中タイマーで再表示するため機能しない。
// 閉じるボタン経由でアプリ内部の比較モードフラグごと戻すのが唯一安全な方法。
// 注意2: queueMicrotaskは実クリック(ネイティブイベント)だとリスナー呼び出しの間に実行され、
// アプリがモーダルを開く前に走って閉じ損ねるためsetTimeoutを使う。
(function () {
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.add-to-comparable, .comparable-custom-action');
      if (!trigger) return;
      var bar = document.querySelector('[data-behavior="comparable-bar"]');
      if (!bar || !bar.classList.contains('comparable-hidden')) return;
      bar.style.setProperty('display', 'none', 'important');
      setTimeout(function () {
        if (!bar.classList.contains('comparable-hidden')) {
          var close = bar.querySelector('[data-behavior="comparable-bar-close"]');
          if (close) close.click();
        }
        bar.style.removeProperty('display');
      }, 0);
    },
    true
  );
  // モーダルの背景クリックで閉じる。
  // .compare-bar自身が全画面オーバーレイを兼ねる(テーマCSS)。タイトル帯はbarの::after擬似要素で
  // クリックターゲットがbar自身になるため、モーダル窓(タイトル+リスト+アクション)の矩形外のみ閉じる。
  document.addEventListener('click', function (event) {
    var bar = event.target;
    if (!bar.matches || !bar.matches('[data-behavior="comparable-bar"]')) return;
    var wrap = bar.querySelector('.compare-products-list-wrapper');
    if (wrap) {
      var actions = bar.querySelector('.compare-products-actions');
      var r1 = wrap.getBoundingClientRect();
      var r2 = actions ? actions.getBoundingClientRect() : r1;
      var titleHeight = parseFloat(getComputedStyle(bar, '::after').height) || 0;
      var inWindow =
        event.clientX >= Math.min(r1.left, r2.left) &&
        event.clientX <= Math.max(r1.right, r2.right) &&
        event.clientY >= Math.min(r1.top, r2.top) - titleHeight &&
        event.clientY <= Math.max(r1.bottom, r2.bottom);
      if (inWindow) return;
    }
    var close = bar.querySelector('[data-behavior="comparable-bar-close"]');
    if (close) close.click();
  });
  // フロートボタンの件数表示の同期。
  // アプリはバーを閉じる時にしか件数を引き直さず、追加確定(非同期fetch)前に閉じる本方式では
  // 連続追加の最後の分が数字に反映されない。バー内リストの増減を監視して都度引き直す。
  function syncStickyCount() {
    var link = document.querySelector('[data-behavior="comparable-sticky-button"] a');
    var span = link && link.querySelector('span');
    if (!span) return;
    var n = 0;
    try {
      n = JSON.parse(localStorage.getItem('comparableProducts') || '[]').length;
    } catch (e) {}
    var label = span.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
    span.textContent = n ? label + ' (' + n + ')' : label;
  }
  function observeBarList() {
    var list = document.querySelector('[data-behavior="comparable-bar-products-list"]');
    if (!list) {
      setTimeout(observeBarList, 500);
      return;
    }
    new MutationObserver(syncStickyCount).observe(list, { childList: true });
  }
  observeBarList();
})();
